import { BrandCaptionLowerThirdEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandCaptionLowerThirdSetEventVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandCaptionLowerThirdSetEventVO.validationSchema(),
    BrandCaptionLowerThirdEntity
  );

  constructor(readonly value: RoomBrandCaptionLowerThirdSetEvent) {
    JsonSchemaValidator.assert(
      RoomBrandCaptionLowerThirdSetEventVO.validation,
      value
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "caption"],
      properties: {
        roomId,
        caption: {
          instanceof: BrandCaptionLowerThirdEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandCaptionLowerThirdSetEvent {
  roomId: RoomId;
  caption: BrandCaptionLowerThirdEntity;
}
